(function () {
  function loadSketchfab(wrap) {
    if (wrap.dataset.sketchfabLoaded === '1') return;
    wrap.dataset.sketchfabLoaded = '1';
    var iframe = document.createElement('iframe');
    iframe.className = 'f24g-sketchfab-frame';
    iframe.title = wrap.dataset.sketchfabTitle || '3D-Modell';
    iframe.setAttribute('allowfullscreen', '');
    iframe.setAttribute('allow', 'autoplay; fullscreen; xr-spatial-tracking');
    iframe.src =
      'https://sketchfab.com/models/' +
      encodeURIComponent(wrap.dataset.sketchfabId) +
      '/embed?autostart=1&autospin=0.2&scrollwheel=0&ui_theme=dark';
    iframe.addEventListener('load', function () {
      wrap.classList.add('f24g-sketchfab-ready');
    });
    window.addEventListener('blur', function onBlur() {
      if (document.activeElement === iframe) {
        wrap.classList.add('f24g-sketchfab-interacted');
        window.removeEventListener('blur', onBlur);
      }
    });
    wrap.appendChild(iframe);
  }

  function initSketchfab(root) {
    var wraps = root.querySelectorAll('.f24g-sketchfab[data-sketchfab-id]');
    if (!wraps.length) return;

    if (!('IntersectionObserver' in window)) {
      wraps.forEach(loadSketchfab);
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          observer.unobserve(entry.target);
          loadSketchfab(entry.target);
        }
      });
    }, { rootMargin: '600px 0px' });

    wraps.forEach(function (wrap) {
      observer.observe(wrap);
    });
  }

  function initGeschichte(root) {
    if (!root || root.dataset.f24gReady === '1') return;
    root.dataset.f24gReady = '1';

    initSketchfab(root);

    if (!('IntersectionObserver' in window)) {
      root.querySelectorAll('.f24g-fade').forEach(function (el) {
        el.classList.add('f24g-visible');
      });
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) entry.target.classList.add('f24g-visible');
      });
      /* Atelier: Kapitel sind höher als der Viewport — ein Prozent-Threshold
         (12%) wird bei so hohen Elementen nie erreicht. threshold 0 +
         kleiner Sichtbarkeits-Puffer statt dessen. */
    }, { threshold: 0, rootMargin: '0px 0px -8% 0px' });

    root.querySelectorAll('.f24g-fade').forEach(function (el) {
      observer.observe(el);
    });
  }

  function boot() {
    document.querySelectorAll('.f24-geschichte').forEach(initGeschichte);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
